import React, { PropsWithChildren } from "react";
import { getIn } from "formik";
import { Label } from "reactstrap";

import { Icon } from "../../../../Icon/Icon";
import { DisplaySettingsFormik } from "../../lib/useDisplaySettingsForm";
import { CustomHexColorsType } from "../../../../../../api/graphql/rooms/rooms";

const themeInputs = [
  {
    title: "free",
    name: "main.layoutTheme.customHexColors.free",
  },
  {
    title: "busy",
    name: "main.layoutTheme.customHexColors.busy",
  },
  {
    title: "tentative",
    name: "main.layoutTheme.customHexColors.tentative",
  },
];

export const ThemeCustomColors = ({
  formik,
}: PropsWithChildren<{
  formik: DisplaySettingsFormik;
}>) => {
  const hasCustomColorsChanged = themeInputs.some(({ name }) => {
    const current = getIn(formik.values, name);
    const initial = getIn(formik.initialValues, name);
    return current !== initial;
  });

  return (
    <div className="flex-a-center ThemeSettings__customColors">
      {themeInputs.map(({ title, name }, index) => (
        <div key={index}>
          <Label for={name}>{title}</Label>

          <div className="ThemeSettings__opacity">
            <span>#</span>
            <input
              key={index}
              name={name}
              id={name}
              type="text"
              value={
                (formik.values.main?.layoutTheme?.customHexColors ?? {})[
                  title as keyof CustomHexColorsType
                ]
              }
              onChange={(e) => {
                formik.handleChange(e);
              }}
              className="text-center ThemeSettings__opacity"
            />
          </div>
        </div>
      ))}

      {hasCustomColorsChanged && (
        <Icon
          onClick={() => {
            themeInputs.forEach(({ name }) => {
              const original = getIn(formik.initialValues, name);
              formik.setFieldValue(name, "");
            });
          }}
          icon="reset"
        />
      )}
    </div>
  );
};
